module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_kasi.5b6de2651b74105af95091be3491d2dc.png";